






import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Home extends Vue {
  gotoActive() {
    this.$router.push('active');
  }
}
